import { CalendarIcon } from "@xola/icons";
import { DatePickerPopover } from "@xola/ui-kit";
import { clampFutureDateRange, DateFormat, formatDate, isFuture, JsDateRange } from "common";
import { Dayjs } from "dayjs";
import React from "react";
import { useSeller } from "../../hooks/useAccount";
import { useLocalizationStore } from "@/stores/localizationStore";

// /**
//  * @deprecated Use JSDateRange from DateHelper instead
//  */
// export interface DateRange {
//     start: Dayjs;
//     end: Dayjs;
// }

interface ReportDatePickerProps {
    value: JsDateRange;
    from: Dayjs;
    to?: Dayjs;
    max?: Dayjs | null;
    disabledDays?: (date: Date) => boolean;
    onChange: (date: JsDateRange) => void;
    isFutureDatesAllowed?: boolean;
}

export const ReportDatePicker = ({
    value,
    from,
    to,
    max,
    disabledDays,
    onChange,
    isFutureDatesAllowed = false,
    ...rest
}: ReportDatePickerProps) => {
    const { timezoneName } = useSeller();
    const locale = useLocalizationStore().getLocale();

    if (!disabledDays) {
        disabledDays = (date) => isFuture(date, "day");
    }

    const handleChange = (value: JsDateRange) => {
        if (max) {
            const newValue = clampFutureDateRange({ ...value }, max);
            return onChange(newValue);
        }

        onChange(value);
    };

    return (
        <DatePickerPopover
            shouldShowYearPicker
            shouldShowRelativeRanges
            variant="range"
            disabledDays={disabledDays}
            locale={locale}
            timezoneName={timezoneName}
            value={value}
            popoverProps={{ placement: "bottom-end", distance: 8 }}
            isFutureDatesAllowed={isFutureDatesAllowed}
            onChange={handleChange}
            {...rest}
        >
            <div className="flex h-10 w-full cursor-pointer items-center rounded border border-gray-light p-3">
                <CalendarIcon className="mr-1" size="medium" />
                <span className="no-translate truncate">
                    {formatDate(from, DateFormat.DATE)}
                    &nbsp;-&nbsp;
                    {value.to && to ? formatDate(to, DateFormat.DATE) : "Pending"}
                </span>
            </div>
        </DatePickerPopover>
    );
};
